// extracted by mini-css-extract-plugin
module.exports = {"legendMobile":"LegendContent_legendMobile__65sOG","legendTitle":"LegendContent_legendTitle__iyjMh","legendList":"LegendContent_legendList__CIQRc"};